// extracted by mini-css-extract-plugin
export default {"tableContainer":"ValueTable_tableContainer__Sxu9P","card":"ValueTable_card__u6RlE","table":"ValueTable_table__a4SQs","tableHeader":"ValueTable_tableHeader__ImrcZ"};